import { HttpMethod, HttpRepository } from "../../core/repository/http_repository";
import { ExamModel } from "./exam_model";

export class ExamHttpRepository extends HttpRepository {
  getPage = (page: number) => this._jsonRequest<ExamModel[]>(HttpMethod.GET, `/exams?page=${page}`);
  getOne = (id: string) => this._jsonRequest<ExamModel>(HttpMethod.GET, `/exams?id=${encodeURIComponent(id)}`);
  save = (model: ExamModel) => this._jsonRequest<{ id?: string; _id?: string }>(model._id ? HttpMethod.PUT : HttpMethod.POST, "/exams", model);
  remove = (id: string) => this._jsonRequest(HttpMethod.DELETE, `/exams?id=${encodeURIComponent(id)}`);
}
